<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2026. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: footer.vue
  - Created by: chan.ying
  - Create Date: 2026-04-27 15:50
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <!--        v-if="!AppConfig.Instance.isModeProd"-->
        <div class="col-sm-6 ztn-font-color">
          Team: {{ currentUser.teamInfo.teamFqdn }}
          ({{ currentUser.teamInfo.teamUID }})
          , Region: {{ currentUser.teamInfo.regionName }}({{ currentUser.teamInfo.geoRegionId }})
        </div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">
            {{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © STRONG-GATE
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
<script>
import OnlineUserManager from "@/security/OnlineUserManager";
import AppConfig from "@/commons/AppConfig";

export default {
  computed: {
    AppConfig() {
      return AppConfig
    },
    currentUser() {
      return OnlineUserManager.Instance.get();
    },
  }
}
</script>